/* globals ServerFormater, XmlElement */
/* eslint-disable new-cap */
function ActivityRunTimeObjective (
    Identifier,
    SuccessStatus,
    CompletionStatus,
    ScoreScaled,
    ScoreRaw,
    ScoreMax,
    ScoreMin,
    ProgressMeasure,
    Description
) {
    this.Identifier = Identifier;
    this.SuccessStatus = SuccessStatus;
    this.CompletionStatus = CompletionStatus;
    this.ScoreScaled = ScoreScaled;
    this.ScoreRaw = ScoreRaw;
    this.ScoreMax = ScoreMax;
    this.ScoreMin = ScoreMin;
    this.ProgressMeasure = ProgressMeasure;
    this.Description = Description;

    this.SuccessStatusChangedDuringRuntime = false;
    this.MeasureChangedDuringRuntime = false;
    this.ProgressMeasureChangedDuringRuntime = false;
    this.CompletionStatusChangedDuringRuntime = false;
}

ActivityRunTimeObjective.prototype = {
    GetXml: function (activityId, index) {
        var ServerFormat = new ServerFormater(),
            xml = new XmlElement("ARTO");

        xml.AddAttribute("AI", activityId);
        xml.AddAttribute("I", index);

        if (this.Identifier !== null) {
            xml.AddAttribute("Id", ServerFormat.TrimToLength(this.Identifier, 4000));
        }

        xml.AddAttribute("SS", ServerFormat.ConvertSuccessStatus(this.SuccessStatus));
        xml.AddAttribute("CS", ServerFormat.ConvertCompletionStatus(this.CompletionStatus));

        if (this.ScoreScaled !== null) {
            xml.AddAttribute("SSc", this.ScoreScaled);
        }
        if (this.ScoreRaw !== null) {
            xml.AddAttribute("SR", this.ScoreRaw);
        }
        if (this.ScoreMax !== null) {
            xml.AddAttribute("SM", this.ScoreMax);
        }
        if (this.ScoreMin !== null) {
            xml.AddAttribute("SMi", this.ScoreMin);
        }
        if (this.ProgressMeasure !== null) {
            xml.AddAttribute("PM", this.ProgressMeasure);
        }
        if (this.Description !== null) {
            xml.AddAttribute("D", ServerFormat.TrimToLength(this.Description, 500));
        }

        return xml.toString();
    },

    toString: function () {
        return "ActivityRunTimeObjective - " + this.Identifier;
    }
};
